import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.orders || initialState;

const makeSelectOrdersList = () =>
  createSelector(select, subState => subState.ordersList);
const makeSelectVitrinOrdersList = () =>
  createSelector(select, subState => subState.vitrinOrdersList);
const makeSelectVitrinOrdersCount = () =>
  createSelector(select, subState => subState.vitrinOrdersCount);
const makeSelectIncomingOrdersList = () =>
  createSelector(select, subState => subState.incomingOrdersList);
const makeSelectIncomingOrdersCount = () =>
  createSelector(select, subState => subState.incomingOrdersCount);
const makeSelectCatList = () =>
  createSelector(select, subState => subState.catList);
const makeSelectTicketsList = () =>
  createSelector(select, subState => subState.ticketsList);
const makeSelectTicketList = () =>
  createSelector(select, subState => subState.ticketList);
const makeSelectTicketCountList = () =>
  createSelector(select, subState => subState.ticketCountList);

const makeSelectAllPostOrders = () =>
  createSelector(select, subState => subState.allPostOrders);

const makeSelectProvinces = () =>
  createSelector(select, subState => subState.provinces);

const makeSelectCities = () =>
  createSelector(select, subState => subState.cities);

const makeSelectOrdersPrintList = () =>
  createSelector(select, subState => subState.ordersPrintList);

const makeSelectAllOrders = () =>
  createSelector(select, subState => subState.allOrdersReport);

const makeSelectAllOrderItems = () =>
  createSelector(select, subState => subState.orderItems);

const makeSelectPostOrder = () =>
  createSelector(select, subState => subState.postOrder);

const makeSelectCurrentPostOrder = () =>
  createSelector(select, subState => subState.currentPostOrder);

const makeSelectPostOrders = () =>
  createSelector(select, subState => subState.postOrders);

const makeSelectLogs = () => createSelector(select, subState => subState.logs);

const makeSelectBundleAssignment = () =>
  createSelector(select, subState => subState.bundleAssignment);

const makeSelectOrder = () =>
  createSelector(select, subState => subState.order);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);
const makeSelectDeliveredCountList = () =>
  createSelector(select, subState => subState.deliveredCount);
const makeSelectDeliveringCountList = () =>
  createSelector(select, subState => subState.deliveringCount);
const makeSelectProcessingCountList = () =>
  createSelector(select, subState => subState.processingCount);
const makeSelectDeliverdPostCountList = () =>
  createSelector(select, subState => subState.deliverdPostCount);
const makeSelectReturnedCountList = () =>
  createSelector(select, subState => subState.returnedCount);

const makeSelectPostOrdersCountList = () =>
  createSelector(select, subState => subState.postOrdersCount);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectCitiesLoading = () =>
  createSelector(select, subState => subState.cityLoading);

const makeSelectProvincesLoading = () =>
  createSelector(select, subState => subState.provinceLoading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

export default select;
export {
  makeSelectTicketCountList,
  makeSelectTicketsList,
  makeSelectTicketList,
  makeSelectCatList,
  makeSelectDeliverdPostCountList,
  makeSelectProcessingCountList,
  makeSelectDeliveredCountList,
  makeSelectDeliveringCountList,
  makeSelectOrdersList,
  makeSelectOrder,
  makeSelectLoading,
  makeSelectCitiesLoading,
  makeSelectProvincesLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectBundleAssignment,
  makeSelectLogs,
  makeSelectAllOrders,
  makeSelectPostOrder,
  makeSelectPostOrders,
  makeSelectOrdersPrintList,
  makeSelectAllPostOrders,
  makeSelectAllOrderItems,
  makeSelectProvinces,
  makeSelectCities,
  makeSelectCurrentPostOrder,
  makeSelectPostOrdersCountList,
  makeSelectReturnedCountList,
  makeSelectVitrinOrdersList,
  makeSelectIncomingOrdersList,
  makeSelectVitrinOrdersCount,
  makeSelectIncomingOrdersCount,
};
